<script setup lang="ts">
import type { LinkNavTab } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'
import { NavigationLinkTabs } from '@shared/ui/menus'

defineOptions({
  name: 'HelpersMenu',
})

const route = useRoute()

const config = computed<LinkNavTab[]>(() => [
  { text: 'Notifications', to: AppRoute.Helpers, selected: route.path === AppRoute.Helpers, disabled: false, visible: true },
  { text: 'Sales & SQA', to: AppRoute.HelpersSales, selected: route.path === AppRoute.HelpersSales, disabled: false, visible: true },
  { text: 'Tutors', to: AppRoute.HelpersTutors, selected: route.path === AppRoute.HelpersTutors, disabled: false, visible: true },
  { text: 'Bookings', to: AppRoute.HelpersBookings, selected: route.path === AppRoute.HelpersBookings, disabled: false, visible: true },
  { text: 'Newsletters', to: AppRoute.HelpersNewsletters, selected: route.path === AppRoute.HelpersNewsletters, disabled: false, visible: true },
  { text: 'Billing & System', to: AppRoute.HelpersSystem, selected: route.path === AppRoute.HelpersSystem, disabled: false, visible: true },
])
</script>

<template>
  <NavigationLinkTabs :config="config" />
</template>
